import { KeyboardEvent as ReactKeyboardEvent } from 'react';

type KizenKeyboardEvent = ReactKeyboardEvent | KeyboardEvent;

// Primarily for excluding events if IME text composition is used for input
export const isComposingKeyboardEvent = (event: KizenKeyboardEvent): boolean =>
  (event instanceof KeyboardEvent
    ? event.isComposing
    : event.nativeEvent?.isComposing) || false;

export const isNonComposingKeyboardEvent = (
  event: KizenKeyboardEvent,
  key: KizenKeyboardEvent['key']
): boolean => event.key === key && !isComposingKeyboardEvent(event);

export const isNonComposingEnterKeyboardEvent = (event: KizenKeyboardEvent) =>
  isNonComposingKeyboardEvent(event, 'Enter');
